import styled from 'styled-components';
import { color } from 'styles/Theme';
import { svg } from 'lib/svgList';

export const ContainerSearch = styled.div`
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	position: relative;

	input {
		padding: 0.8rem 3rem 0.8rem 0.8rem;
		background-image: url(${svg.icon.searchBold});
		background-repeat: no-repeat;
		background-position: calc(100% - 20px);
		background-size: 1rem;
		outline: 0;
		border: 1px solid ${color.interface.lightGray};
		border-radius: 30px;
		font-weight: 400;
		width: 100%;
	}
	input::placeholder {
		font-weight: 400;
	}
	button {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		align-items: center;
		justify-content: space-between;
		background-color: ${color.interface.white};
		cursor: pointer;
		transition: 0.5 all ease;
		border-radius: 7px;
		border: 1px solid ${color.interface.lightGray};
	}
	img {
		width: 15px;
		height: 15px;
	}
	img:active {
		transform: scale(0.9);
	}
`;
export const ListTi = styled.div`
	@keyframes show {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	font-size: 1rem;
	width: 100%;
	max-height: 300px;
	overflow: auto;
	padding: 1rem;
	position: absolute;
	top: 60px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 0.5rem;
	border: 1px solid ${color.interface.lightGray};
	border-radius: 10px;
	background-color: ${color.interface.whiteAbsolute};
	z-index: 10;
	font-weight: 400;

	animation-name: show;
	animation-duration: 1s;

	::-webkit-scrollbar-track {
		background: ${color.interface.white}; /* color of the tracking area */
	}

	::-webkit-scrollbar-thumb {
		background-color: ${color.interface.gray}99; /* color of the scroll thumb */
		border: 1px solid ${color.interface.gray}99; /* creates padding around scroll thumb */
	}

	button {
		width: 100%;
		font-size: 1rem;
		background-color: transparent;
		font-weight: 400;
		cursor: pointer;
		border: none;
		display: flex;
		align-items: flex-start;
		transition: all 0.3s ease;

		:hover {
			background-color: ${color.interface.orange};
			color: ${color.interface.white};
			border-radius: 7px;
		}
	}
`;

export const itemList = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const line = styled.div`
	width: 100%;
	height: 0.5px;
	background-color: ${color.interface.lightGray};
	transition: all ease 0.5s;
`;

export const containerBoxItems = styled.div`
	top: 100%;
	width: 100%;
	margin-top: 15px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	flex-wrap: wrap;
`;
